import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SvgLoaderService} from './svg-loader.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [SvgLoaderService]
})
export class SvgLoaderModule {}
